// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"Section_sectionWrapper__kxVl7"};